import { useField } from 'formik';
import React from 'react';
import { isReadOnly } from 'utilities/JSUtil';
import '../Form.scss';

const TextAreaInput = ({ label, ...props }) => {
    const [field, meta, helpers] = useField(props);

    let classes = 'form-input-value'

    let requiredLabel = undefined
    let error = undefined

    if (props.isrequired) {
        requiredLabel = '*'
    }

    if (meta.error) {
        error = <div className='invalid'>{meta.error}</div>
    }

    return (
        <div className='form-input'>
            {label && <label htmlFor={props.name} className='form-input-label'>
                {label}{requiredLabel}
                <br />
            </label>
            }
            <div className={classes}>
                <textarea {...field} {...props} title={props.title || label} autoComplete="off" disabled={props.overridedisabledflag === 'true' ? false : (isReadOnly() || props.disabled)} />
                {error}
            </div>
        </div>
    );
};

export default TextAreaInput